import Grid2 from '@mui/material/Unstable_Grid2';
import { Step } from '../../components/Step';
import HomeIcon from '@mui/icons-material/Home';
import { useTranslation } from 'react-i18next';
import Select from 'src/shared/components/Form/Select';
import { mapArrayForSelect } from '../../utils/mapArrayForSelect';
import { useFormState } from 'react-final-form';

type Step2Props = { data: string[] };

export const Step2 = ({ data }: Step2Props) => {
  const { t } = useTranslation('settings');
  const {
    values: { subsidiary }
  } = useFormState();

  const mappedData = mapArrayForSelect(data);

  return (
    <Step
      title={`${t('integrations.step')} 2`}
      subtitle={`${t('integrations.personio.connect your subcompany')}:`}
      Icon={HomeIcon}
    >
      <>
        <Grid2 xs={12}>
          <Select sx={{ maxWidth: '300px' }} data={mappedData} label={subsidiary} name="subcompany" />
        </Grid2>
      </>
    </Step>
  );
};
